import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "percentScale",
    standalone: false
})
export class PercentScalePipe implements PipeTransform
{
    transform(value: string): string
    {
        return percentScale(value);
    }
}

const regex = /\B(?=(\d{3})+(?!\d))/g;
export function percentScale(value: unknown): string
{
    if (!value)
    {
        return "";
    }

    return value.toString().replace(regex, ",") + "%";
}
